import { getFeatureFlag } from 'core/service/feature-flag/feature-flag.service';
import { DEFAULT_FEATURE_FLAGS } from 'core/service/feature-flag/feature-flag.constants';
import { FeatureFlag } from 'core/service/feature-flag/feature-flag.model';
import { usePocQuery } from 'core/custom-hooks/use-poc-query.hook';
import { featureFlagKeys } from 'core/query-client/keys/feature-flag.keys';
import { executeRequest } from 'core/utils/backend-service';

export interface UseFeatureFlagsReturn {
    featureFlags: FeatureFlag[];
    isLoading: boolean;
}

export const useFeatureFlags = (): UseFeatureFlagsReturn => {
    const { data: featureFlags = DEFAULT_FEATURE_FLAGS, isFetching: isLoading } = usePocQuery<FeatureFlag[]>({
        queryKey: featureFlagKeys.list(),
        queryFn: () => executeRequest(() => getFeatureFlag()) as Promise<FeatureFlag[]>,
        staleTime: Infinity,
    });

    return { featureFlags, isLoading };
};
